import { CurrencyPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyWithoutCents'
})
export class CurrencyWithoutCentsPipe implements PipeTransform {
  locale: string;

  constructor(
    @Inject(LOCALE_ID) locale: string,
    private currencyPipe: CurrencyPipe
  ) {
    this.locale = locale;
  }

  transform(value: number): string | null {
    return this.currencyPipe.transform(
      value,
      '',
      'symbol-narrow',
      '1.0-0',
      this.locale
    );
  }
}
